<template>
  <div class="qtoolbar d-flex justify-space-between align-center">
    <div class="d-flex align-center">
      <img class="qTimerIcon" src="../../assets/images/timer_48.svg" />
      <div class="qTimer">{{ formattedTime }}</div>
    </div>
    <div class="qTimer">
      <span class="cQuestion">Question {{ currentQuestionNumber }}</span>
      <span class="rQuestion">of {{ questionCount }}</span>
    </div>
  </div>
  <v-progress-linear :model-value="(currentQuestionNumber / questionCount) * 100" color="success"></v-progress-linear>
  <div class="tBody">
    <label v-for="(option, index) in options" :key="index" class="radio-label">
      <input type="radio" :value="option" v-model="selectedOption" :name="groupName" class="radio-input" />
      <span class="radio-custom"></span>
      <span class="radio-text">{{ option }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "TopBar",
  props: {
    minutes: {
      type: Number,
      required: true,
    },
    questionCount: {
      type: Number,
      required: true,
    },
    currentQuestionNumber: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      timeInSeconds: this.minutes * 60,
      intervalId: null,
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.timeInSeconds / 60);
      const seconds = this.timeInSeconds % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
  },
  methods: {
    startCountdown() {
      this.intervalId = setInterval(() => {
        if (this.timeInSeconds > 0) {
          this.timeInSeconds--;
        } else {
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
  },
  mounted() {
    this.startCountdown();
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
};
</script>

<style scoped lang="scss">
@import "node_modules/shared-components/assets/style/color.scss";
.qtoolbar {
  background-color: $c_dark;
}

.qTimerIcon {
  color: $c_white_smoke;
  width: 24px;
}
.qTimer {
  font-size: 22px;
  color: $c_white_smoke;
}
.cQuestion {
  padding-right: 8px;
}
.rQuestion {
  color: $c_davys_grey;
}
</style>
